import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight'
import { Color, RoutePath } from '../../../constants'
import Button from '../../shared/Button'

export default function ExploreTheMapButton() {
  const navigate = useNavigate()
  return (
    <Button
      onClick={() => navigate(RoutePath.Map)}
      textColor={Color.White}
      backgroundColor={Color.Black}
    >
      <p className="text-[16px] uppercase flex-1 font-bold">Explore the map</p>
      <FontAwesomeIcon icon={faArrowRight} />
    </Button>
  )
}
